// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"3184a962","489":"5349d4fa"}[chunkId] + ".js";
};